export function setUser(state, user) {
    state.user = user;
    var today = new Date(); 
    state.date = today.toISOString().substring(0,10);
}

export function setGlobales(state, glob) {
    state.globales = glob;
    console.log(state.globales)
}

export function setTokenDevice(state, tokendevice) {
    state.token_device = tokendevice 
}

export function setShowMenu(state, _show) {
    state.showMenu = _show
}

export function setAccessToken(state, accesstoken) {
    state.isLogged = true
    state.error = false
    state.errorMessage = ''
    state.access_token = accesstoken
}

export function logout(state, res) {
    state.user = null
    state.globales = []
    state.date = null
    state.isLogged = false
    state.error = false
    state.errorMessage = ''
    state.access_token = ''
}

export function authError(state, error) {
    state.error = true
    state.errorMessage = error
    state.user = null
    state.globales = []
    state.isLogged = false
}
